var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request } from '@max/meituan-uni-network';
import { AntiReqTool } from '@nibfe/h5guard-request';
const isWeb = true;
import { getCityInfo } from '@max/meituan-uni-city';
import { PlatformType, getPlatformType } from '@nibfe/mkt-env-api';
import { getActuralCityId } from '../utils/cityUtils';
import { getUTM } from '../utils/getUTM';
;
;
const PlatformEnum = {
    mtApp: 1,
    // 美团app
    mtAppWebView: 1,
    dpApp: 2,
    // 点评App
    mtDpAppWebview: 2,
    mtMinaWebview: 3,
    // 美团微信小程序
    mtHotelMinaWebview: 4,
    // 美团酒店微信小程序
    mtDpMinaWebview: 5 // 点评微信小程序
};
var PlatformApiType;
(function (PlatformApiType) {
    PlatformApiType[PlatformApiType["mt"] = 1] = "mt";
    PlatformApiType[PlatformApiType["dp"] = 2] = "dp";
})(PlatformApiType || (PlatformApiType = {}));
const baseURL = 'https://ihotel.meituan.com';
// const baseURL = 'https://api.hotel.test.meituan.com'; // NOTE:important 上线切换
const DEFAULT_CITY_ID = 1;
const platform = getPlatformType();
const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView, PlatformType.dpMinaWebview].includes(platform);
export const getCurrentCityId = function (isDp) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const currentCityInfo = yield getCityInfo({
                type: isDp ? 'dp' : 'mt',
                _wechat: {
                    _mt: {
                        sceneToken: 'dd-9cbc1c31cfbf2bba'
                    }
                }
            });
            console.log('currentCityId', currentCityInfo === null || currentCityInfo === void 0 ? void 0 : currentCityInfo.id);
            return currentCityInfo === null || currentCityInfo === void 0 ? void 0 : currentCityInfo.id;
        }
        catch (e) {
            return DEFAULT_CITY_ID;
        }
    });
};
export const getPredictCity = function (params, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        const isPtest = false; // NOTE:important ptest环境测试，上线前需置为false
        let url = `${baseURL}/landing/page/cityFilter/queryPredictCityInfo`;
        let finalData = params;
        if (true) {
            try {
                const antiReq = new AntiReqTool({
                    autoFillParams: true
                });
                // @ts-ignore
                finalData = antiReq.addCommonParams(finalData);
            }
            catch (e) {
                console.warn('添加反爬参数失败', e);
                // reportJSInfo({ level: 'info', content: '请求加上反爬参数错误', secCategory: 'ajaxError' });
            }
        }
        const newPromise = new Promise((resolve, reject) => {
            request({
                url,
                data: Object.assign({}, finalData),
                method: 'POST',
                header: {
                    'content-type': 'application/json'
                    // 'swimlane': 'wangshiyang05-mnnbt' // NOTE:important 泳道环境测试，上线前需注释掉
                },
                _meituan: {
                    requestType: 'MRNUtils',
                    mrnChannel: 'hotel',
                    params: finalData
                },
                success(res) {
                    var _a, _b, _c;
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === 0) {
                        resolve((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : {});
                    }
                    else {
                        resolve({});
                    }
                },
                fail(e) {
                    console.warn('网络开小差了');
                    ctx === null || ctx === void 0 ? void 0 : ctx._raptorReport.reportLog('城市预测接口获取失败', e, {
                        category: 'ajaxError',
                        level: 'info'
                    });
                    resolve({});
                }
            });
        });
        return newPromise;
    });
};
// 接口文档https://km.sankuai.com/collabpage/2708114941
export const getActuralDefaultCity = (params) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { ctx, isPredictCity = false, userInfo } = params;
    let acturalCityInfo = getActuralCityId({
        ctx
    });
    try {
        if (isPredictCity) {
            const cityId = acturalCityInfo.cityId && acturalCityInfo.type !== 'default' ? acturalCityInfo.cityId : '';
            // 当前定位城市
            const locateCityId = (yield getCurrentCityId(isDp)) || DEFAULT_CITY_ID;
            const params = {
                cityId,
                locateCityId,
                platform: isDp ? PlatformApiType.dp : PlatformApiType.mt,
                source: PlatformEnum[platform] || PlatformEnum.mtApp,
                userId: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) || '',
                token: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.token) || '',
                utm_campaign: isDp ? 'Adianping-novaBdianping-novaD0H0' : 'Meituan',
                // 决定筛选POI的城市体系
                version_name: (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) === null || _b === void 0 ? void 0 : _b.appVersion,
                utm_medium: getUTM()
            };
            const res = yield getPredictCity(params, ctx);
            console.log('getPredictCity', res);
            if (res === null || res === void 0 ? void 0 : res.predictCityName) {
                const predictCityId = isDp ? res === null || res === void 0 ? void 0 : res.predictDpCityId : res === null || res === void 0 ? void 0 : res.predictMtCityId;
                acturalCityInfo = {
                    cityId: predictCityId,
                    type: 'predict'
                };
            }
            return acturalCityInfo;
        }
    }
    catch (e) {
        console.log('get predict city error', e);
    }
    return acturalCityInfo;
});
